import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Context } from "../../../../../index";
import { observer } from "mobx-react-lite";
import ButtonUI from "../../../../UI/ButtonUI/ButtonUI";
import clsx from "clsx";
import { ReactComponent as RefreshIcon } from "../../../../../assets/icons/refresh.svg";

const AuthStep = observer((props) => {
  const { user } = useContext(Context);
  const inputsRef = useRef([]);
  const [digits, setDigits] = useState(["", "", "", ""]);

  React.useEffect(() => {
    user.counterSecondCode > 0 &&
      setTimeout(
        () => user.setCounterSecondCode(user.counterSecondCode - 1),
        1000
      );
  }, [user.counterSecondCode]);

  const handleCombinedClick = () => {
    if (user.counterSecondCode === 0) {
      props.getCodeOneMoreTime();
    }
  };

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newDigits = [...digits];
    newDigits[index] = value;
    setDigits(newDigits);

    const code = newDigits.join("");
    props.codeChange({ target: { value: code } });

    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }

    if (code.length === 4) {

    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
    if(e.target.value.length > 0){
      if(e.key !== "Enter" && e.key !== "Backspace"){
        e.preventDefault()
        return false
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").slice(0, 4);
    const newDigits = [...digits];

    for (let i = 0; i < pasteData.length; i++) {
      if (i < 4 && /^\d$/.test(pasteData[i])) {
        newDigits[i] = pasteData[i];
      }
    }

    setDigits(newDigits);
    const code = newDigits.join("");
    props.codeChange({ target: { value: code } });

    if (pasteData.length === 4) {
      inputsRef.current[3].focus();
    } else if (pasteData.length > 0) {
      inputsRef.current[pasteData.length].focus();
    }
  };

  useEffect(() => {
    if(user.stepModals === "authStep" && digits[0] == "" && user.openAuthModal === 1){
      inputsRef.current[0].focus()
    }
  })

  const submit = (e) => {
    e.preventDefault()
    if(user.authSmsCode.length == 4){
      props.loginFunc()
    }
  }

  return (
    <form onSubmit={submit} className={"auth_step " + props.controllStateClass}>
      <div className={"number_step_fields"}>
        <span className={"number_step_fields__title"}>Введите код из СМС</span>
        <noindex className={"number_step_fields__text"}>
          Отправили код на номер <span>{user.phoneNumber}</span>
        </noindex>
        <div className="auth_sms_code-wrapper">
          <div className="auth_sms_code-container">
            <div className="auth_sms_code-container-inputs">
              {digits.map((digit, index) => (
                <React.Fragment key={index}>
                  <input
                    ref={(el) => (inputsRef.current[index] = el)}
                    type="number"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    className={clsx("auth_sms_code-input", {
                      "auth_sms_code-input--error": user.codeMessage,
                    })}
                    autoFocus={index === 0}
                  />
                </React.Fragment>
              ))}
            </div>
            {user.codeMessage ? (
              <span className={"error_message_sms"}>{user.codeMessage}</span>
            ) : null}
          </div>

          {user.counterSecondCode > 0 ? (
            <span
              className={clsx(
                "counter_sms_get_code",
                "counter_sms_get_code--disabled"
              )}
            >
              {"Отправить повторно через 0:" + user.counterSecondCode.toString().padStart(2,'0')}
            </span>
          ) : (
            <span
              className={"counter_sms_get_code"}
              onClick={handleCombinedClick}
            >
              <RefreshIcon />
              Получить код еще раз
            </span>
          )}
          <ButtonUI
            className={"auth_sms_code-button"}
            disabled={user.authSmsCode.length !== 4}
            text={"Подтвердить номер"}
            type={"submit"}
          />
        </div>
        {props.captchaNode}
      </div>
    </form>
  );
});

export default AuthStep;
